const SupportIcon: React.FC<{ size?: number, color?: string }> = ({ size = 20, color = "#8C92A2" }) => (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 11.3807 2.87919 12.6739 3.54688 13.7891L2.5 17.5L6.21094 16.4531C7.32607 17.1208 8.61929 17.5 10 17.5Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.5 8.75H7.50625" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 8.75H10.0063" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5 8.75H12.5063" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default SupportIcon;
